import { ErrorMessage, Field, getIn } from 'formik';
import React from 'react';
import CustomSelect from '../../../../common/formElements/CustomSelect';
import CustomInputWithIcon from '../../../../common/ui/CustomInputWithIcon';

const FileExtraSetting = ({ setFieldValue, setFieldTouched, getFileTypes, values }) => {
  return (
    <>
      <div className="col-md-6 col-lg-6 col-sm-12 col-xs-12">
        <CustomInputWithIcon icon="sort-up" extraCss="bmd-form-group">
          <Field
            type="number"
            name="validation.noAllowedFiles"
            className="form-control"
            data-lang="en"
            min="1"
            placeholder="Total Number of Files to be attached"
          />
          <p className="errors">
            <ErrorMessage name="validation.noAllowedFiles" />
          </p>
        </CustomInputWithIcon>
      </div>
      <div className="col-md-6 col-lg-6 col-sm-12 col-xs-12 mt-4">
        <CustomInputWithIcon icon="files">
          <CustomSelect
            key={'validation.allowedFileTypes'}
            name={'validation.allowedFileTypes'}
            isMulti={true}
            onChange={setFieldValue}
            onBlur={setFieldTouched}
            options={getFileTypes()}
            value={getIn(values, 'validation.allowedFileTypes')}
            placeholder="Allowed File Types"
          />
          <p className="errors">
            <ErrorMessage name="validation.allowedFileTypes" />
          </p>
        </CustomInputWithIcon>
      </div>
    </>
  );
};

export default FileExtraSetting;
